/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { makeAutoObservable } from "mobx"

import type { PageApplicationId, PageApplicationList } from "./application-types"

export class ApplicationStore {
    readonly applications: Map<string, PageApplicationList> = new Map<string, PageApplicationList>()
    selectedPageId: PageApplicationId | null = null

    constructor() {
        makeAutoObservable(this, {
            setApplications: true,
            setSelectedPageId: true
        })
    }

    getApplications(pageId: PageApplicationId): PageApplicationList | null {
        return this.applications.get(pageToKey(pageId)) ?? null
    }

    setApplications(pageId: PageApplicationId, applications: PageApplicationList): void {
        this.applications.set(pageToKey(pageId), applications)
    }

    // used only in VM when found cached page
    setSelectedPageId(pageId: PageApplicationId): void {
        this.selectedPageId = pageId
    }
}

/*
 * Deliberately keep this separator private to the cache key. `|` separates the fields, so
 * flags need a different separator to avoid making the key ambiguous.
 */
const pageToKey = (page: Pick<PageApplicationId, "appTypeId" | "status" | "flags" | "page">): string =>
    `${page.appTypeId}|${page.status}|${page.flags.join(",")}|${page.page}`
